var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7857 0H3.21429C1.43906 0 0 1.43906 0 3.21429V26.7857C0 28.5609 1.43906 30 3.21429 30H26.7857C28.5609 30 30 28.5609 30 26.7857V3.21429C30 1.43906 28.5609 0 26.7857 0ZM26.7857 26.7857H3.21429V3.21429H26.7857V26.7857ZM24.3841 10.5988L12.8268 22.0634C12.5117 22.3759 12.0029 22.3739 11.6904 22.0588L5.61134 15.9305C5.29882 15.6155 5.30083 15.1067 5.61596 14.7941L7.13732 13.285C7.45239 12.9725 7.96118 12.9745 8.27371 13.2896L12.2776 17.326L21.7432 7.93654C22.0582 7.62402 22.567 7.62603 22.8796 7.94109L24.3887 9.46239C24.7012 9.77752 24.6992 10.2863 24.3841 10.5988Z",
    fill: "#2BE0B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.2d303ccb31118d9b0c3c8889a416a231.svg";
export { ForwardRef as ReactComponent };